// Endless brand "did you mean" suggestion
// Runs on /search results page only

(function () {
  if (!window.location.pathname.startsWith('/search')) return;

  const params = new URLSearchParams(window.location.search);
  const query = (params.get('q') || '').trim();
  if (!query || query.length < 2) return;

  // Approved brand list with collection slugs
  // Source: /pages/approved-brand-list
  // Format: [brandName, collectionSlug]
  const BRANDS = [
    ['A.P.C.', 'a-p-c'],
    ['Abercrombie & Fitch', 'abercrombie-fitch'],
    ['Abyss by Abby', 'abyss-by-abby'],
    ['Acler', 'acler'],
    ['Acne Studios', 'acne-studios'],
    ['Agua Bendita', 'agua-bendita'],
    ['Aje', 'aje'],
    ['Alexa Chung', 'alexa-chung'],
    ['Alexander McQueen', 'alexander-mcqueen'],
    ['Alexander Wang', 'alexander-wang'],
    ['Alexandre Birman', 'alexandre-birman'],
    ['Alexandre Vauthier', 'alexandre-vauthier'],
    ['Alexis', 'alexis'],
    ['Alice + Olivia', 'alice-olivia'],
    ['Alice McCall', 'alice-mccall'],
    ['All Saints', 'all-saints'],
    ['Amanda Uprichard', 'amanda-uprichard'],
    ['Amy Jane London', 'amy-jane-london'],
    ['Ancient Kallos', 'ancient-kallos'],
    ['Anine Bing', 'anine-bing'],
    ['Anitas', 'anitas'],
    ['Anna Quan', 'anna-quan'],
    ['Anne Louise Boutique', 'anne-louise-boutique'],
    ['Anthropologie', 'anthropologie'],
    ['AQAQ', 'aqaq'],
    ['Aquazzura', 'aquazzura'],
    ['Arcina Ori', 'arcina-ori'],
    ['Armani Exchange', 'armani-exchange'],
    ['Armarium', 'armarium'],
    ['Avec Les Filles', 'avec-les-filles'],
    ['Axel Arigato', 'axel-arigato'],
    ['Badgley Mischka', 'badgley-mischka'],
    ['Balenciaga', 'balenciaga'],
    ['Balmain', 'balmain'],
    ['Banana Republic', 'banana-republic'],
    ['Baobab', 'baobab'],
    ['Bardot', 'bardot'],
    ['Baruni', 'baruni'],
    ['Baum Und Pferdgarten', 'baum-und-pferdgarten'],
    ['BCBGMAXAZRIA', 'bcbgmaxazria'],
    ['Beach City', 'beach-city'],
    ['Bec + Bridge', 'bec-bridge'],
    ['Bella Barnett', 'bella-barnett'],
    ['Borgo De Nor', 'borgo-de-nor'],
    ['Bottega Veneta', 'bottega-veneta'],
    ['Bouguessa', 'bouguessa'],
    ['Bronx & Banco', 'bronx-banco'],
    ['Brunello Cucinelli', 'brunello-cucinelli'],
    ['Bulgari', 'bulgari'],
    ['Burberry', 'burberry'],
    ['BUUB', 'buub'],
    ['By Alle', 'by-alle'],
    ['By Far', 'by-far'],
    ['By Keara', 'by-keara'],
    ['Camila Coelho', 'camila-coelho'],
    ['Camilla And Marc', 'camilla-and-marc'],
    ['Celine', 'celine'],
    ['Chanel', 'chanel'],
    ['Charlotte Olympia', 'charlotte-olympia'],
    ['Charo Ruiz Ibiza', 'charo-ruiz-ibiza'],
    ['Chats By C.Dam', 'chats-by-c-dam'],
    ['Chi Chi London', 'chi-chi-london'],
    ['Chic Le Frique', 'chic-le-frique'],
    ['Chloe', 'chloe'],
    ['Christian Louboutin', 'christian-louboutin'],
    ['Christopher Esber', 'christopher-esber'],
    ['Christopher Kane', 'christopher-kane'],
    ['Claudie Pierlot', 'claudie-pierlot'],
    ['Club L London', 'club-l-london'],
    ['Coach', 'coach'],
    ['Comptoir Des Cotonniers', 'comptoir-des-cotonniers'],
    ['Coperni', 'coperni'],
    ['COS', 'cos'],
    ['Coucoo', 'coucoo'],
    ['Cult Gaia', 'cult-gaia'],
    ['Cynthia Rowley', 'cynthia-rowley'],
    ['De La Vali', 'de-la-vali'],
    ['Diane Von Furstenberg', 'diane-von-furstenberg'],
    ['Dion Lee', 'dion-lee'],
    ['Dior', 'dior'],
    ['Dissh', 'dissh'],
    ['Dolce & Gabbana', 'dolce-gabbana'],
    ['Elisabetta Franchi', 'elisabetta-franchi'],
    ['Elliatt', 'elliatt'],
    ['Else Adelia', 'else-adelia'],
    ['Emilio Pucci', 'emilio-pucci'],
    ['Erdem', 'erdem'],
    ['Essentiel Antwerp', 'essentiel-antwerp'],
    ['Faithfull The Brand', 'faithfull-the-brand'],
    ['Farai London', 'farai-london'],
    ['Farm Rio', 'farm-rio'],
    ['Fendi', 'fendi'],
    ['Ferragamo', 'ferragamo'],
    ['Finders Keepers', 'finders-keepers'],
    ['For Love & Lemons', 'for-love-lemons'],
    ['Free People', 'free-people'],
    ['French Connection', 'french-connection'],
    ['Frou Frou', 'frou-frou'],
    ['Ganni', 'ganni'],
    ['Gauge81', 'gauge81'],
    ['Gentle Monster', 'gentle-monster'],
    ['Gianmarco Lorenzi', 'gianmarco-lorenzi'],
    ['Gianvito Rossi', 'gianvito-rossi'],
    ['Giuseppe Zanotti', 'giuseppe-zanotti'],
    ['Givenchy', 'givenchy'],
    ['Goyard', 'goyard'],
    ['Greek Archaic Kori', 'greek-archaic-kori'],
    ['Gucci', 'gucci'],
    ['Guess', 'guess'],
    ['Harmur', 'harmur'],
    ['Helmut Lang', 'helmut-lang'],
    ['Hemant & Nandita', 'hemant-nandita'],
    ['Hermes', 'hermes'],
    ['Herve Leger', 'herve-leger'],
    ['House of CB', 'house-of-cb'],
    ['Hudson', 'hudson'],
    ['Hugo Boss', 'hugo-boss'],
    ['IRO', 'iro'],
    ['Isabel Marant', 'isabel-marant'],
    ['Isabel Moore', 'isabel-moore'],
    ['IttyBittyKinis', 'ittybittykinis'],
    ['J. Crew', 'j-crew'],
    ['Jacquemus', 'jacquemus'],
    ['Jaded London', 'jaded-london'],
    ['Jenny Yoo', 'jenny-yoo'],
    ['Jil Sander', 'jil-sander'],
    ['Jimmy Choo', 'jimmy-choo'],
    ['Jonathan Simkhai', 'jonathan-simkhai'],
    ['Jovani', 'jovani'],
    ['JW Anderson', 'jw-anderson'],
    ['JW Pei', 'jw-pei'],
    ['Karl Lagerfeld', 'karl-lagerfeld'],
    ['Kate Spade', 'kate-spade'],
    ['Katie May', 'katie-may'],
    ['Keepsake The Label', 'keepsake-the-label'],
    ['Kenzo', 'kenzo'],
    ['Khaite', 'khaite'],
    ["Khanum's", 'khanums'],
    ['Kookai', 'kookai'],
    ['Krisa', 'krisa'],
    ['Kurt Geiger', 'kurt-geiger'],
    ['Kyha Studios', 'kyha-studios'],
    ['Lavish Alice', 'lavish-alice'],
    ['Le Poppy', 'le-poppy'],
    ['Les Heroines', 'les-heroines'],
    ['Leslie Amon', 'leslie-amon'],
    ["L'IDEE", 'lidee'],
    ['Limerick', 'limerick'],
    ['Lioness', 'lioness'],
    ['Loeffler Randall', 'loeffler-randall'],
    ['Loewe', 'loewe'],
    ['Longchamp', 'longchamp'],
    ['Louis Vuitton', 'louis-vuitton'],
    ['Love Moschino', 'love-moschino'],
    ['Lovers + Friends', 'lovers-friends'],
    ['LoveShackFancy', 'loveshackfancy'],
    ['Mac Duggal', 'mac-duggal'],
    ['Mach & Mach', 'mach-mach'],
    ['Made with Love', 'made-with-love'],
    ['Magda Butrym', 'magda-butrym'],
    ['Maje', 'maje'],
    ['Majorelle', 'majorelle'],
    ['Malone', 'malone'],
    ['Manolo Blahnik', 'manolo-blahnik'],
    ['Marc Jacobs', 'marc-jacobs'],
    ['Marchesa Notte', 'marchesa-notte'],
    ['Marella', 'marella'],
    ['Maria Lucia Hohan', 'maria-lucia-hohan'],
    ['Marni', 'marni'],
    ['Massimo Dutti', 'massimo-dutti'],
    ['Mayka', 'mayka'],
    ['Melani The Label', 'melani-the-label'],
    ['Melissa Phair', 'melissa-phair'],
    ['Meshki', 'meshki'],
    ['Mew Mews', 'mew-mews'],
    ['Miaou', 'miaou'],
    ['Michael Costello', 'michael-costello'],
    ['Michael Kors', 'michael-kors'],
    ['Michael Lo Sordo', 'michael-lo-sordo'],
    ['Miharo', 'miharo'],
    ['Millie Modelli', 'millie-modelli'],
    ['Misha', 'misha'],
    ['Miss Circle', 'miss-circle'],
    ['Missoni', 'missoni'],
    ['Miu Miu', 'miu-miu'],
    ['Monday Swimwear', 'monday-swimwear'],
    ['Moschino', 'moschino'],
    ['MSGM', 'msgm'],
    ['Mugler', 'mugler'],
    ['Mulberry', 'mulberry'],
    ['Musier Paris', 'musier-paris'],
    ['Mykaftan', 'mykaftan'],
    ['Nadine Merabi', 'nadine-merabi'],
    ['Nanushka', 'nanushka'],
    ['Nass', 'nass'],
    ['Natalie Rolt', 'natalie-rolt'],
    ['NBD', 'nbd'],
    ['Needle & Thread', 'needle-thread'],
    ['Never Fully Dressed', 'never-fully-dressed'],
    ['Nood', 'nood'],
    ['Nookie', 'nookie'],
    ['Nora The Label', 'nora-the-label'],
    ['Norma Kamali', 'norma-kamali'],
    ['Oceanus', 'oceanus'],
    ['Odd Muse', 'odd-muse'],
    ['Off-White', 'off-white'],
    ['Oh Polly', 'oh-polly'],
    ['Olivia Rubin', 'olivia-rubin'],
    ['Oseree', 'oseree'],
    ['Oysho', 'oysho'],
    ['Paco Rabanne', 'paco-rabanne'],
    ['Paris Texas', 'paris-texas'],
    ['Patrizia Pepe', 'patrizia-pepe'],
    ['Peppermayo', 'peppermayo'],
    ['Phair', 'phair'],
    ['Phillip Plein', 'phillip-plein'],
    ['Pinko', 'pinko'],
    ['POCA & POCA', 'poca-poca'],
    ['Polene', 'polene'],
    ['Post Meridiem', 'post-meridiem'],
    ['Prada', 'prada'],
    ['Pretty Lavish', 'pretty-lavish'],
    ['Pucci', 'pucci'],
    ['Raey', 'raey'],
    ['Rag & Bone', 'rag-bone'],
    ['Ralph Lauren', 'ralph-lauren'],
    ['Rat & Boa', 'rat-boa'],
    ['Réalisation Par', 'realisation-par'],
    ['Rebecca Minkoff', 'rebecca-minkoff'],
    ['Rebecca Vallance', 'rebecca-vallance'],
    ['Reclaimed Vintage', 'reclaimed-vintage'],
    ['Red Valentino', 'red-valentino'],
    ['Reformation', 'reformation'],
    ['Reiss', 'reiss'],
    ['Rejina Pyo', 'rejina-pyo'],
    ['Retrofete', 'retrofete'],
    ['Rhea Costa', 'rhea-costa'],
    ['Rixo', 'rixo'],
    ['Roberto Cavalli', 'roberto-cavalli'],
    ['Romani', 'romani'],
    ['Ronny Kobo', 'ronny-kobo'],
    ['Roopa Pemmaraju', 'roopa-pemmaraju'],
    ['Rotate Birger Christensen', 'rotate-birger-christensen'],
    ['Runaway The Label', 'runaway-the-label'],
    ['Sabo', 'sabo'],
    ['Sakuranna', 'sakuranna'],
    ['Saloni', 'saloni'],
    ['Samsoe Samsoe', 'samsoe-samsoe'],
    ['Sandro', 'sandro'],
    ['Sanobar Antule', 'sanobar-antule'],
    ['Sarabloo', 'sarabloo'],
    ['Saylor', 'saylor'],
    ['Scarlett Poppies', 'scarlett-poppies'],
    ['Self-Portrait', 'self-portrait'],
    ['Sergio Hudson', 'sergio-hudson'],
    ['Sergio Rossi', 'sergio-rossi'],
    ['Sevgi', 'sevgi'],
    ['Shona Joy', 'shona-joy'],
    ['Show Me Your Mumu', 'show-me-your-mumu'],
    ['Significant Other', 'significant-other'],
    ['Sir The Label', 'sir-the-label'],
    ['Skims', 'skims'],
    ['SLA The Label', 'sla-the-label'],
    ['SNDYS', 'sndys'],
    ['Solace London', 'solace-london'],
    ['Someri', 'someri'],
    ['Sophia Webster', 'sophia-webster'],
    ['Sosandar', 'sosandar'],
    ['Staud', 'staud'],
    ['Steele', 'steele'],
    ['Stella McCartney', 'stella-mccartney'],
    ['Stuart Weitzman', 'stuart-weitzman'],
    ['Tala', 'tala'],
    ['Taller Marmo', 'taller-marmo'],
    ['The Attico', 'the-attico'],
    ['The Concept', 'the-concept'],
    ['The Dolls House', 'the-dolls-house'],
    ['The Kooples', 'the-kooples'],
    ['The New Arrivals Ilkyaz Ozel', 'the-new-arrivals-ilkyaz-ozel'],
    ['The Row', 'the-row'],
    ["Tod's", 'tods'],
    ['Tom Ford', 'tom-ford'],
    ['Toteme', 'toteme'],
    ['Ulla Johnson', 'ulla-johnson'],
    ['Underhance', 'underhance'],
    ['Urbnwhyt', 'urbnwhyt'],
    ['Valentino Garavani', 'valentino-garavani'],
    ['Versace', 'versace'],
    ['Vesper', 'vesper'],
    ['Victoria Beckham', 'victoria-beckham'],
    ['Vince Camuto', 'vince-camuto'],
    ['Vivienne Westwood', 'vivienne-westwood'],
    ['Whistles', 'whistles'],
    ['Winona', 'winona'],
    ['With Jean', 'with-jean'],
    ['Yves Saint Laurent', 'yves-saint-laurent'],
    ['Zadig & Voltaire', 'zadig-voltaire'],
    ['Zimmermann', 'zimmermann']
  ];

  // Levenshtein distance
  function levenshtein(a, b) {
    if (a === b) return 0;
    const m = a.length;
    const n = b.length;
    if (m === 0) return n;
    if (n === 0) return m;
    const prev = new Array(n + 1);
    const curr = new Array(n + 1);
    for (let j = 0; j <= n; j++) prev[j] = j;
    for (let i = 1; i <= m; i++) {
      curr[0] = i;
      for (let j = 1; j <= n; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
      }
      for (let j = 0; j <= n; j++) prev[j] = curr[j];
    }
    return prev[n];
  }

  // Generic terms that should never trigger a brand suggestion
  const STOP_WORDS = new Set([
    'dress', 'dresses', 'gown', 'gowns', 'top', 'tops', 'tee', 'tees',
    'shirt', 'shirts', 'tshirt', 'tshirts', 'blouse', 'blouses',
    'pants', 'trouser', 'trousers', 'jean', 'jeans', 'short', 'shorts',
    'skirt', 'skirts', 'jumpsuit', 'jumpsuits', 'romper', 'rompers',
    'coord', 'coords', 'set', 'sets',
    'jacket', 'jackets', 'coat', 'coats', 'blazer', 'blazers',
    'suit', 'suits', 'tux', 'tuxedo', 'tuxedos',
    'swimsuit', 'swimwear', 'bikini', 'bikinis',
    'lingerie', 'underwear',
    'bag', 'bags', 'handbag', 'handbags', 'clutch', 'clutches',
    'tote', 'totes', 'backpack', 'backpacks',
    'shoe', 'shoes', 'heel', 'heels', 'flat', 'flats',
    'sneaker', 'sneakers', 'boot', 'boots', 'sandal', 'sandals',
    'belt', 'belts', 'scarf', 'scarves', 'hat', 'hats',
    'sunglass', 'sunglasses', 'glasses',
    'jewelry', 'jewellery', 'necklace', 'earring', 'earrings',
    'bracelet', 'ring', 'rings',
    'wedding', 'bridal', 'bride', 'bridesmaid',
    'party', 'cocktail', 'evening', 'formal', 'casual',
    'brunch', 'vacay', 'vacation', 'holiday',
    'maxi', 'midi', 'mini',
    'rental', 'rent', 'resale', 'sale', 'new',
    'black', 'white', 'red', 'blue', 'green', 'yellow', 'pink',
    'purple', 'gold', 'silver', 'beige', 'nude', 'cream',
    'long', 'tall', 'slim', 'oversized', 'cropped',
    'silk', 'satin', 'lace', 'velvet', 'leather', 'denim',
    'the', 'and', 'of', 'by', 'a', 'an'
  ]);

  // Common brand abbreviations and nicknames
  const ALIASES = {
    'ysl': 'Yves Saint Laurent',
    'saint laurent': 'Yves Saint Laurent',
    'lv': 'Louis Vuitton',
    'louis v': 'Louis Vuitton',
    'mk': 'Michael Kors',
    'd&g': 'Dolce & Gabbana',
    'dolce gabbana': 'Dolce & Gabbana',
    'dg': 'Dolce & Gabbana',
    'mcqueen': 'Alexander McQueen',
    'alex wang': 'Alexander Wang',
    'wang': 'Alexander Wang',
    'apc': 'A.P.C.',
    'rl': 'Ralph Lauren',
    'ralph': 'Ralph Lauren',
    'cdg': 'Comptoir Des Cotonniers',
    'bottega': 'Bottega Veneta',
    'margiela': 'Maison Margiela',
    'mm6': 'Maison Margiela',
    'aj': 'Amy Jane London',
    'free people': 'Free People',
    'self portrait': 'Self-Portrait',
    'selfportrait': 'Self-Portrait',
    'off white': 'Off-White',
    'rotate': 'Rotate Birger Christensen',
    'birger christensen': 'Rotate Birger Christensen',
    'norma': 'Norma Kamali',
    'kamali': 'Norma Kamali',
    'choo': 'Jimmy Choo',
    'jc': 'Jimmy Choo',
    'cl': 'Christian Louboutin',
    'louboutin': 'Christian Louboutin',
    'rat boa': 'Rat & Boa',
    'rat and boa': 'Rat & Boa',
    'ratboa': 'Rat & Boa',
    'rat & boa': 'Rat & Boa',
    'realisation': 'Réalisation Par',
    'realisation par': 'Réalisation Par',
    'gucc': 'Gucci',
    'mugla': 'Mugler',
    'zimmerman': 'Zimmermann'
  };

  // Synonyms: maps a search term to a better search term
  // When matched, re-runs the search with the canonical term
  const SYNONYMS = {
    // Bags
    'purse': 'bag',
    'purses': 'bags',
    'handbag': 'bag',
    'handbags': 'bags',
    // Shoes
    'trainers': 'sneakers',
    'kicks': 'sneakers',
    'pumps': 'heels',
    'stilettos': 'heels',
    // Dresses
    'frock': 'dress',
    'frocks': 'dresses',
    'gown': 'dress',
    'gowns': 'dresses',
    // Tops & bottoms
    'tee': 'top',
    'tees': 'tops',
    'tshirt': 'top',
    't-shirt': 'top',
    // Swim
    'swimsuit': 'swimwear',
    'swimsuits': 'swimwear',
    // Misc
    'mens': "men's",
    'tuxedo': 'tux'
  };

  // Strip diacritics so "Réalisation" and "realisation" match
  function stripDiacritics(str) {
    return String(str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  // Normalize: strip diacritics, lowercase, strip non-alphanumeric
  function normalize(str) {
    return stripDiacritics(String(str || ''))
      .toLowerCase()
      .replace(/[^a-z0-9]/g, '');
  }

  // Build a lookup of canonical brand names for alias resolution
  const BRAND_BY_NAME = {};
  for (const [name, slug] of BRANDS) {
    BRAND_BY_NAME[name] = slug;
  }

  // Find closest brand match
  function findSuggestion(query) {
    const qNorm = normalize(query);
    if (!qNorm) return null;

    const queryLower = stripDiacritics(query).toLowerCase().trim();

    // Step 1: check aliases first
    if (ALIASES[queryLower]) {
      const canonical = ALIASES[queryLower];
      const slug = BRAND_BY_NAME[canonical];
      if (slug && normalize(canonical) !== qNorm) {
        return { name: canonical, slug };
      }
    }

    // Step 2: skip if query exactly matches a brand
    for (const [name] of BRANDS) {
      if (normalize(name) === qNorm) return null;
    }

    // Step 3: strip stop words
    const queryWords = queryLower.split(/\s+/).filter(Boolean);
    const meaningfulWords = queryWords.filter(w => !STOP_WORDS.has(normalize(w)));
    if (meaningfulWords.length === 0) return null;

    const cleanedQuery = meaningfulWords.join(' ');
    const cleanedNorm = normalize(cleanedQuery);
    if (!cleanedNorm) return null;

    if (ALIASES[cleanedQuery]) {
      const canonical = ALIASES[cleanedQuery];
      const slug = BRAND_BY_NAME[canonical];
      if (slug && normalize(canonical) !== qNorm) {
        return { name: canonical, slug };
      }
    }

    for (const [name] of BRANDS) {
      if (normalize(name) === cleanedNorm) return null;
    }

    let best = null;
    let bestDist = Infinity;

    for (const [name, slug] of BRANDS) {
      const bNorm = normalize(name);
      if (!bNorm) continue;

      const fullDist = levenshtein(cleanedNorm, bNorm);
      const fullThreshold = bNorm.length <= 4 ? 1 : bNorm.length <= 7 ? 2 : 3;

      if (fullDist <= fullThreshold && fullDist < bestDist) {
        best = { name, slug };
        bestDist = fullDist;
      }

      const brandWords = stripDiacritics(name).toLowerCase().split(/\s+/);
      const significantBrandWords = brandWords
        .map(w => normalize(w))
        .filter(w => w.length >= 3 && !STOP_WORDS.has(w));

      for (const qWord of meaningfulWords) {
        const qWordNorm = normalize(qWord);
        if (qWordNorm.length < 3) continue;

        for (const bWord of significantBrandWords) {
          const wordDist = levenshtein(qWordNorm, bWord);
          const wordThreshold = bWord.length <= 4 ? 1 : 2;

          if (wordDist <= wordThreshold && wordDist < bestDist) {
            best = { name, slug };
            bestDist = wordDist;
          }
        }
      }
    }

    return best;
  }

  // Check if query matches a synonym → suggest the canonical search term
  function findSynonymMatch(query) {
    const q = stripDiacritics(query).toLowerCase().trim();
    if (SYNONYMS[q]) {
      const canonical = SYNONYMS[q];
      return { name: canonical, searchQuery: canonical };
    }
    return null;
  }

  // Render banner above the "X results found for" text
  function renderSuggestion(suggestion) {
    if (document.getElementById('endless-brand-suggest')) return;

    const allElements = document.querySelectorAll('p, h1, h2, h3, div, span');
    let resultsEl = null;
    for (const el of allElements) {
      const text = (el.textContent || '').trim();
      if (
        /^\d+\s+results?\s+found\s+for/i.test(text) &&
        el.children.length === 0
      ) {
        resultsEl = el;
        break;
      }
    }

    const banner = document.createElement('div');
    banner.id = 'endless-brand-suggest';
    banner.style.cssText = [
      'margin: 0 auto 12px',
      'padding: 0',
      'font-size: 13px',
      'line-height: 1.4',
      'color: #555',
      'text-align: center',
      'max-width: 1200px'
    ].join(';');

    // Synonym → re-search. Brand → collection page.
    let url;
    if (suggestion.searchQuery) {
      url = `/search?q=${encodeURIComponent(suggestion.searchQuery)}`;
    } else {
      url = `/collections/${suggestion.slug}`;
    }

    banner.innerHTML =
      `Did you mean <a href="${url}" style="font-weight:500;text-decoration:underline;color:#1a1a1a;">${suggestion.name}</a>?`;

    if (resultsEl && resultsEl.parentElement) {
      resultsEl.parentElement.insertBefore(banner, resultsEl);
      return;
    }

    const inputs = document.querySelectorAll('input[name="q"]');
    let visibleInput = null;
    for (const inp of inputs) {
      const rect = inp.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        visibleInput = inp;
        break;
      }
    }

    if (visibleInput) {
      const wrapper = visibleInput.closest('form') || visibleInput.parentElement;
      wrapper.insertAdjacentElement('afterend', banner);
      return;
    }

    const main = document.querySelector('main') || document.querySelector('#MainContent');
    if (main) main.prepend(banner);
  }

  // Count visible product results
  function countResults() {
    const selectors = [
      '.product-grid .product-item',
      '.product-grid .grid__item',
      '.product-list .product-item',
      '[data-product-id]',
      '.product-card',
      '.card-product',
      '.grid-product'
    ];
    for (const sel of selectors) {
      const found = document.querySelectorAll(sel);
      if (found.length > 0) return found.length;
    }
    return null;
  }

  // Run after DOM is ready
  function run() {
    try {
      const resultCount = countResults();
      if (resultCount !== null && resultCount > 3) return;

      // Try brand match first
      let suggestion = findSuggestion(query);

      // If no brand match, try synonym match
      if (!suggestion) {
        suggestion = findSynonymMatch(query);
      }

      if (suggestion) {
        renderSuggestion(suggestion);
      }
    } catch (e) {
      console.warn('Brand suggest error:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();